import { SET_TOASTIFY } from '../types';

export default (state = {value:'', theme: 'light', isError: false}, action) => {
  switch (action.type) {
    case SET_TOASTIFY:
      return action.payload;
    default:
      return state;
  }
};
